import {v4 as uuidv4} from "uuid";


export default function SummaryTable(props) {


  const cartSum = props.cart.reduce((value, item) => value + item.price, 0)


  return (
    <table className="table">
      <thead>
      <tr>
        <th>Name</th>
        <th>Anzahl</th>
        <th>Preis</th>
      </tr>
      </thead>
      <tbody>
      {props.cart.map((i, idx) => (
        <tr key={idx}>
          <td>{i.product.name}</td>
          <td>
            {i.product.type?.startsWith('element_obwodowy') ? (
              <span>{i.product.price.toFixed(2)} €/Meter</span>
            ) : (
              <span>{i.value}{i.value > 1 ? `x ${i.product.price.toFixed(2)} €` : ''}</span>
            )}
          </td>
          <td>{(i.price)?.toFixed(2)} €</td>
        </tr>
      ))}
      </tbody>
      <tfoot>
      <tr>
        <td colSpan={2}/>
        <td>Zusammen: {cartSum.toFixed(2)} €</td>
      </tr>
      </tfoot>
    </table>
  )
}